import axios  from "axios"

export default {
    async getFarmProducts(dataOptions,cat,farm) {
         var url=`reporting/production-report?cat=${cat}&page=${dataOptions.page}&limit=${dataOptions.limit}`
        if(farm != '')
            url = `${url}&farm=${farm}`
            // if(dataOptions.sortBy.length)
            // url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
            .then(({data}) => data)
            .catch( error => Promise.reject(error));
    },
    async getProductLog(dataOptions,product,farm) {
         var url=`reporting/production-report/${product}?page=${dataOptions.page}&limit=${dataOptions.limit}`
        if(farm != '')
            url = `${url}&farm=${farm}`
            // if(dataOptions.sortBy.length)
            // url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
            .then(({data}) => data)
            .catch( error => Promise.reject(error));
    },
    async getAllProducts(dataOptions,farm) {
        console.log("farm",farm)
         var url=`ntr/product/getAllProducts?page=${dataOptions.page}&limit=${dataOptions.limit}`
        if(farm != '')
            url = `${url}&farmNumber=${farm}`
            // if(dataOptions.sortBy.length)
            // url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
            .then(({data}) => data)
            .catch( error => Promise.reject(error));
    },
    async getProductsOrder(productNumber) {
        var url=`order/detailsByProduct/${productNumber}`
    //    if(farm != '')
    //        url = `${url}&farm=${farm}`
           // if(dataOptions.sortBy.length)
           // url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
       return await axios.get(url)
           .then(({data}) => data)
           .catch( error => Promise.reject(error));
   },
   async getBirthInfo(dataOptions,farm) {
    var url=`reporting/breeder-report/birth-info?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
    console.log(farm)
//    if(farm != '')
//        url = `${url}&farm=${farm}`
       // if(dataOptions.sortBy.length)
       // url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
   return await axios.get(url)
       .then(({data}) => data)
       .catch( error => Promise.reject(error));
},
async getPregnencyCheck(dataOptions,farm) {
    var url=`reporting/breeder-report/pregnency-check?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
    console.log(farm)
//    if(farm != '')
//        url = `${url}&farm=${farm}`
       // if(dataOptions.sortBy.length)
       // url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
   return await axios.get(url)
       .then(({data}) => data)
       .catch( error => Promise.reject(error));
},
async getSemenDetails(dataOptions, farm) {
    var url=`reporting/breeder-report/semen?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
    console.log(farm)
//    if(farm != '')
//        url = `${url}&farm=${farm}`
       // if(dataOptions.sortBy.length)
       // url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
   return await axios.get(url)
       .then(({data}) => data)
       .catch( error => Promise.reject(error));
},
async getEmbroyDetails(dataOptions, farm) {
    var url=`reporting/breeder-report/embryo?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
    console.log(farm)
//    if(farm != '')
//        url = `${url}&farm=${farm}`
       // if(dataOptions.sortBy.length)
       // url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
   return await axios.get(url)
       .then(({data}) => data)
       .catch( error => Promise.reject(error));
},
async getConception(dataOptions, farm) {
    var url=`reporting/breeder-report/conception?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
    console.log(farm)
//    if(farm != '')
//        url = `${url}&farm=${farm}`
       // if(dataOptions.sortBy.length)
       // url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
   return await axios.get(url)
       .then(({data}) => data)
       .catch( error => Promise.reject(error));
},
async getdataConception(dataOptions, farm) {
    var url=`reporting/data-scientist/insemination?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
   if(farm != '')
       url = `${url}&farm=${farm}`
       // if(dataOptions.sortBy.length)
       // url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
   return await axios.get(url)
       .then(({data}) => data)
       .catch( error => Promise.reject(error));
},
async getdatageno(dataOptions, farm) {
    var url=`reporting/data-scientist/genotype-performance?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
   if(farm != '')
       url = `${url}&farm=${farm}`
       // if(dataOptions.sortBy.length)
       // url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
   return await axios.get(url)
       .then(({data}) => data)
       .catch( error => Promise.reject(error));
},
async getCountbreeder() {
    var url=`reporting/breeder-report/counts`
   return await axios.get(url)
       .then(({data}) => data)
       .catch( error => Promise.reject(error));
},

    async getCountsFarmProducts() {
       var url=`reporting/production-report/countProducts`
      return await axios.get(url)
          .then(({data}) => data)
          .catch( error => Promise.reject(error));
  },

    async getAllAnimalSemenData(data, search = "") {
        const { sortBy, sortDesc, page, itemsPerPage } = data;
        var url = `/semen-embryo-report/semen`;
        url = `${url}?page=${page}&limit=${itemsPerPage}`;
        if (search != "") url = `${url}&search=${search}`;
        if (sortBy.length === 1 && sortDesc.length === 1)
          url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`;
    
        return await axios
          .get(url)
          .then(({ data }) => data)
          .catch((error) => {
            return Promise.reject(error.response);
          });
    },

    async getAllAnimalEmbryoData(data, search = "") {
        const { sortBy, sortDesc, page, itemsPerPage } = data;
        var url = `/semen-embryo-report/embryo`;
        url = `${url}?page=${page}&limit=${itemsPerPage}`;
        if (search != "") url = `${url}&search=${search}`;
        if (sortBy.length === 1 && sortDesc.length === 1)
          url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`;
    
        return await axios
          .get(url)
          .then(({ data }) => data)
          .catch((error) => {
            return Promise.reject(error.response);
          });
    },
}